import React from "react";
import { useSelector } from "react-redux";
import useMediaQuery from "hooks/use-media-query";
import ComingsoonPage from "components/comingsoon-page";
import Footer from "components/footer";
import Header from "components/header";
import Loading from "components/loading";
import Walkthrough from "components/walkthrough/walkthrough";
import { FEATURE_FLAGS } from "config/feature-flags";
import { getComingSoon, getIsLoading } from "store/selector";

const App = ({ children }) => {
  const comingSoon = useSelector(getComingSoon);
  const isLoading = useSelector(getIsLoading);
  const { isDesktop } = useMediaQuery();

  return comingSoon ? (
    <ComingsoonPage />
  ) : (
    <>
      {FEATURE_FLAGS.ENABLE_WALKTHROUGH && <Walkthrough />}
      {isLoading && <Loading />}
      <Header hamburger={true} />
      <main
        style={{
          backgroundColor: "#f4f7fC",
          marginTop: isDesktop ? "90px" : "72px",
        }}
      >
        {children}
      </main>
      <Footer />
    </>
  );
};

export default App;
